var _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 130,
    viewBox: "0 0 170 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 162,
    height: 117,
    rx: 5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4 13C4 10.2386 6.23858 8 9 8H161C163.761 8 166 10.2386 166 13V26H4V13Z",
    fill: "#1778E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 59,
    y: 36,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 39,
    y: 36,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 79,
    y: 36,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99,
    y: 36,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 119,
    y: 36,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 59,
    y: 56,
    width: 14,
    height: 13,
    fill: "#1778E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 79,
    y: 56,
    width: 14,
    height: 13,
    fill: "#1778E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 20,
    y: 56,
    width: 13,
    height: 13,
    fill: "#1778E1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 39,
    y: 56,
    width: 14,
    height: 13,
    fill: "#1778E1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99,
    y: 56,
    width: 14,
    height: 13,
    fill: "#1778E1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 119,
    y: 56,
    width: 13,
    height: 13,
    fill: "#1778E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 59,
    y: 75,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 79,
    y: 75,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 20,
    y: 75,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 39,
    y: 75,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99,
    y: 75,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 119,
    y: 75,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 59,
    y: 95,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 79,
    y: 95,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 20,
    y: 95,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 39,
    y: 95,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99,
    y: 95,
    width: 14,
    height: 14,
    fill: "#1778E1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 119,
    y: 95,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 138,
    y: 36,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 138,
    y: 56,
    width: 13,
    height: 13,
    fill: "#1778E1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 138,
    y: 75,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 138,
    y: 95,
    width: 13,
    height: 14,
    fill: "#1778E1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#1778E1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#1778E1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#1778E1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#1778E1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#1778E1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 6,
    height: 16,
    rx: 3,
    fill: "#1778E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 5,
    width: 170,
    height: 125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.291963 0 0 0 0 0.291963 0 0 0 0 0.291963 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.28fb528c.svg";
export { ForwardRef as ReactComponent };